<template>
<div>
    <div class="apply" :class="{'c': $store.state.apply_now,'o': !$store.state.apply_now}">
        <template >
            <div class="apply-container">
                <img :src="$store.state.static_img_url+'pic/apply-bg.png'"> 
                <img :src="$store.state.static_img_url+'pic/apply-button.png'" @click="haddleApplyTry2(10)"> 
            </div>
            <img class="cha" :src="$store.state.static_img_url+'pic/close.png'" @click="close">
        </template>
    </div>
    <img class="close-img" :class="{'c': $store.state.apply_now,'o': !$store.state.apply_now}" :src="$store.state.static_img_url+'pic/apply-close.png'" @click="open"> 
</div>
</template>
<script>
export default {
    inject: ['haddleApplyTry2'],
    data() {
        return {
            apply_modal: false
        }
    },
    components: {
        
    },
    methods: {
        close() {
            this.$store.commit('updateApplyNow', true)
        },
        open() {
            this.$store.commit('updateApplyNow', false)
        },
        applyModelClose(bl) {
            this.apply_modal = bl
        }
    }
}
</script>
<style lang="stylus" scoped>
.apply
    position fixed
    bottom 0
    left 0
    width 100%
    height 100px
    z-index 10
    background rgba(35,41,77,.9)
    transform translateX(0)
    transition all 2s
    &.c
        transform translateX(-100%)
    &.o
        transition all 2s 2s
.apply-container
    width 1200px
    margin 0 auto
    height 100%
    position relative
    img:nth-child(1)
        height 151px
        position absolute
        left 120px
        bottom -10px
    img:nth-child(2)
        height 56px
        position absolute
        right 120px
        bottom 16px
        animation scl .66s infinite alternate
        -webkit-animation scl .66s infinite alternate
        display block
        cursor pointer
img.cha
    height 18px
    position absolute
    right 40px
    top 20px
    cursor pointer
@keyframes scl
    0% 
        transform scale(1) 
    50% 
        transform scale(1.2) 
    100% 
        transform scale(1.1) 
.close-img
    position fixed
    left 0
    bottom 0
    height 152px
    cursor pointer
    transform translateX(-173px)
    transition all 2s 2s
    &.c
        transform translateX(0)
    &.o
        transition all 2s
</style>